module.exports = __webpack_public_path__ + "static/2018_SF_Family-170ea9a84a0bea92f9220a8a5b37f04d.jpg";